import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';
import { ClienteSearchModel } from './../models/clienti/cliente-search.model';
import { ClienteModel } from '../models/clienti/cliente.model';
import { ClienteListItemModel } from '../models/clienti/cliente-list-item.model';
import { Configurations } from "../core/configurations";
import { DizionarioModel } from './../models/shared/dizionario.model';
import { guid } from "../core/utilities";
import {AuthService} from "./auth.service";
//OLD
//const CLIENTI_LIST = '/list.json';
//const CLIENTI_DETAIL = '/detail.json';


@Injectable()
export class ClientiService {
  APIClienti = this.configuration.apiBaseUrlClienti;
  MethodLista= "listaClienti";
  MethodUpdate="update";
  constructor(private http: Http, private configuration: Configurations, private authenticationService: AuthService) {

 }

  getList(model: ClienteSearchModel): Observable<ClienteListItemModel[]> {
    
    let searchParams = model || new ClienteSearchModel();
    return this.http.post(this.APIClienti + this.MethodLista ,  searchParams)
    .map((r: Response) => r.json() as ClienteListItemModel[]).catch((r:any)=> {
        
      if(r.status === 401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {
          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
  }

  get(gid: string): Observable<ClienteModel> {
    
    return this.http.get(this.APIClienti + '/'+gid)
    .map((r: Response) => r.json() as ClienteModel).catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
  }

  update(model:ClienteModel): Observable<Response> {
    let url = this.APIClienti+this.MethodUpdate+"/"+model.token;
    return this.http.put(url, model)
    .map(res =>  res.json() )
    .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r);
    });
  }
}

//OLD
/*
export const CLIENTI: ClienteModel[] = [
  {
    token: "01",
    zona: "z01",
    idZona: 1,
    partitaIva: "00011122233",
    ragioneSociale: "Cliente A srl",
    citta: "Genova",
    indirizzo: "indirizzo cliente A",
    codiceClienteAS400: "00001",
    latitudine: 44.416116,
    longitudine: 8.997983,
    stato: {id:1, descrizione:'Attivo'},
    situazionePartite: {id:1, descrizione:'Da saldare'},
    telefono: '010 1234567',
    cellulare: '333 12312312',
    eMail: '',
    coordinateVerificateSulPosto: false,
    sedeCodiceComune: '',
    sedeIndirizzo:''
  },
  {
    token: "02",
    zona: "z01",
    idZona: 1,
    partitaIva: "00011122244",
    ragioneSociale: "Cliente B srl",
    citta: "Torino",
    indirizzo: "indirizzo cliente B",
    codiceClienteAS400: "00002",
    latitudine: 45.056769,
    longitudine:  7.612130,
    situazionePartite: {id:1, descrizione:'Da saldare'},
    stato: {id:1, descrizione:'Attivo'},
    telefono: '011 9834384',
    cellulare: '333 12312312',
    eMail: '',
    coordinateVerificateSulPosto: false,
    sedeCodiceComune: '',
    sedeIndirizzo:''
  },
  {
    token: "03",
    zona: "z02",
    idZona: 2,
    partitaIva: "00011122255",
    ragioneSociale: "Cliente C srl",
    citta: "Milano",
    indirizzo: "indirizzo cliente C",
    codiceClienteAS400: "00003",
    latitudine: 45.526616,
    longitudine: 9.2033193,
    situazionePartite: {id:1, descrizione:'Da saldare'},
    stato: {id:1, descrizione:'Attivo'},
    telefono: '02 1234567',
    cellulare: '334 12312312',
    eMail: '',
    coordinateVerificateSulPosto: false,
    sedeCodiceComune: '',
    sedeIndirizzo:''
  },
  {
    token: guid(),
    zona: "z01",
    idZona: 1,
    partitaIva: "00011122252",
    ragioneSociale: "Cliente D spa",
    citta: "Milano",
    indirizzo: "indirizzo cliente D",
    codiceClienteAS400: "00004",
    latitudine: 45.5407429,
    longitudine: 9.2850607,
    situazionePartite: {id:1, descrizione:'Da saldare'},
    stato: {id:1, descrizione:'Attivo'},
    telefono: '02 99945234',
    cellulare: '334 2232312',
    eMail: '',
    coordinateVerificateSulPosto: false,
    sedeCodiceComune: '',
    sedeIndirizzo:''
  }

];
*/



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/clienti.service.ts